{
  "gateway_server.asset_not_found": "הנכס לא נמצא.",
  "gateway_server.verify_body": "השלם בדיקה מהירה זו לפני שתמשיך להירשם.",
  "gateway_server.verify_continue_action": "המשך",
  "gateway_server.verify_failed_error": "האימות נכשל.",
  "gateway_server.verify_failed_retry": "בדיקת האימות נכשלה. אנא נסה שוב.",
  "gateway_server.verify_heading": "אמת כדי להמשיך",
  "gateway_server.verify_load_error": "לא ניתן היה לטעון את בדיקת האימות. אנא נסה שוב.",
  "gateway_server.verify_missing_token_error": "אנא השלם את בדיקת האימות.",
  "gateway_server.verify_page_title": "אימות | Tov+",
  "gateway_server.waitlist_body": "אנו פותחים כעת גישה למתכננים בשלבים. משתמשים קיימים עדיין יכולים להתחבר כרגיל.",
  "gateway_server.waitlist_heading": "הצטרפו ל־Tov+ דרך רשימת ההמתנה.",
  "gateway_server.waitlist_page_title": "רשימת המתנה | Tov+",
  "gateway_server.waitlist_primary_action": "הצטרף לרשימת ההמתנה",
  "gateway_server.waitlist_secondary_action": "חזור להתחברות"
}
